import script from "./FileDragElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileDragElement.vue?vue&type=script&setup=true&lang=ts"

import "./FileDragElement.vue?vue&type=style&index=0&id=5ed7192d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed7192d"]])

export default __exports__